import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "GradientScoreWrapper" }
const _hoisted_2 = {
  class: "CoverCircle First50",
  ref: "first50Circle"
}
const _hoisted_3 = {
  class: "CoverCircle Second50",
  ref: "second50Circle"
}
const _hoisted_4 = { class: "ScoreCircle" }
const _hoisted_5 = {
  key: 0,
  class: "ScoreLabel"
}
const _hoisted_6 = { class: "Score" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("figure", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.isBelow50 ? 'Score-x' : _ctx.scoreCircleStyle, "GradientCircle GradientBackgroundSecond50"])
    }, null, 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.isBelow50 ? 'Score-x' : _ctx.scoreCircleStyle, "GradientCircle GradientBackgroundFirst50"])
    }, null, 2 /* CLASS */),
    _createElementVNode("div", _hoisted_2, null, 512 /* NEED_PATCH */),
    _createElementVNode("div", _hoisted_3, null, 512 /* NEED_PATCH */),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.displayScore.label !== '')
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.displayScore.label), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("span", _hoisted_6, [
        _createTextVNode(_toDisplayString(_ctx.displayScore.score), 1 /* TEXT */),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "Percentage" }, "%", -1 /* HOISTED */))
      ])
    ])
  ]))
}